import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { saveCookieConsent } from "@/lib/api";
import { loadRemarketing } from "@/lib/analytics";

const KEY = "tenet_cookie_consent_v1";
const ALL_COOKIES = { necessary: true, analytics: true, marketing: true };

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // All cookies are applied on this site; the banner is an acknowledgment notice.
    loadRemarketing();
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const acknowledge = () => {
    localStorage.setItem(KEY, JSON.stringify(ALL_COOKIES));
    saveCookieConsent(ALL_COOKIES).catch(() => {});
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-5" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-stone-200 p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <i className="fa-solid fa-cookie-bite text-[#1F3D2E] text-lg mt-1 sm:mt-0" />
          <div className="flex-1">
            <h4 className="font-playfair text-lg text-stone-900">A note about cookies</h4>
            <p className="text-sm text-stone-600 mt-1 leading-relaxed">
              We use cookies to keep the site working, understand what's helpful, and support gentle
              remarketing. By continuing to use this site, you agree to our use of cookies. See our{" "}
              <Link to="/privacy" className="text-[#1F3D2E] underline">privacy policy</Link>.
            </p>
          </div>
          <button
            data-testid="cookie-accept-all"
            onClick={acknowledge}
            className="btn-terracotta rounded-full px-6 py-2.5 text-sm font-semibold whitespace-nowrap shrink-0"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
